
<template>
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-6">
        <img src="@/assets/images/totalcheck_logo.png" alt="TotalCheck Logo" class="img-fluid">
      </div>
      <div class="col-1 p-0" style="max-width: 2px;">
        <hr class="divider bg-primary">
      </div>
      <div class="col-5">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in banners" :key="index">
            <img class="img-fluid" :src="item.image" style="max-height: 150px" :alt="item.name">
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'swiper-example-vertical',
  title: 'Vertical slider',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: 'vertical',
        loop: true,
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: {
          delay: 1200,
          disableOnInteraction: false
        },
      },
      banners: [
        {
          name: "Acura Logo",
          image: require("@/assets/images/acura.png")
        },
        {
          name: "Buick Logo",
          image: require("@/assets/images/buick.png")
        },
        {
          name: "Chevrolet Logo",
          image: require("@/assets/images/chevrolet.png")
        },
        {
          name: "Chrysler Logo",
          image: require("@/assets/images/chrysler.png")
        },
        {
          name: "Dodge Logo",
          image: require("@/assets/images/dodge.png")
        },
        {
          name: "Fiat Logo",
          image: require("@/assets/images/fiat.png")
        },
        {
          name: "honda Logo",
          image: require("@/assets/images/honda.jpg")
        },
        {
          name: "Hyundai Logo",
          image: require("@/assets/images/hyundai.jpg")
        },
        {
          name: "Jeep Logo",
          image: require("@/assets/images/jeep.png")
        },
        {
          name: "Kia Logo",
          image: require("@/assets/images/kia.png")
        },
        {
          name: "Mercedes Logo",
          image: require("@/assets/images/mercedes.jpg")
        },
        {
          name: "Nissan Logo",
          image: require("@/assets/images/nissan.png")
        },
        {
          name: "Ram Logo",
          image: require("@/assets/images/ram.png")
        },
        {
          name: "Toyota Logo",
          image: require("@/assets/images/toyota.png")
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  max-width: 1000px;
  margin-top: 50px;
  margin-bottom: 50px;
}

.swiper {
  height: 450px;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    background-color: white;
  }
}

.divider {
  height: 5rem;
  -webkit-transform: translateY(-10%);
  transform: translateY(-10%);
  width: 100%;
}

@media (max-width: 930px) {
  .container {
    max-width: 80rem;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>
